import classnames from 'classnames';
import React__default from 'react';
import '../stack/index.js';
import { list } from './list.css.js';
import { Stack } from '../stack/stack.js';

const defaultListElement = 'ul';
/**
 * Creates a list (ordered or unordered) of items
 */
const List = React__default.forwardRef(function List({ children, className, as, direction = 'column', ...rest }, ref) {
    const Element = as || defaultListElement;
    return (React__default.createElement(Stack, { direction: direction, wrap: false, as: Element, className: classnames(list, className), ref: ref, ...rest }, children));
});

export { List };
